import React from 'react'

export const ContainerFull = ({ children }) => {
    return (
        <div className="w-full box-border px-[2.5%] my-4">
            {children}
        </div>
    )
}
